import type {FinalPlotData} from '../includes/load_data'
import type {FeatureLike} from 'ol/Feature'

export const processFeatureData = (feature: FeatureLike, featureData: FinalPlotData | undefined) => {
  const output: featureProcessedData = {
    name: feature.get('name'),
    status: undefined,
    area: undefined,
    priceTotalNum: undefined,
    priceTotalDiscountNum: undefined,
    pricePerNum: undefined,
    pricePerDiscountNum: undefined,
    kad: undefined,
    field_link_to_special_export: undefined,
  }

  if (!featureData) {
    return output
  }

  if (featureData.field_status_export) {
    switch (featureData.field_status_export) {
      case 'Забронирован':
        output.status = {
          state: 'hold',
          name: featureData.field_status_export,
        }
        break
      case 'Продан':
        output.status = {
          state: 'sold',
          name: featureData.field_status_export,
        }
        break
      case 'Акция':
        output.status = {
          state: 'discount',
          name: featureData.field_status_export,
        }
        break
      case 'Спецпредложение':
        output.status = {
          state: 'special',
          name: featureData.field_status_export,
        }
        break
      case 'Ипотека':
        output.status = {
          state: 'mortgage',
          name: featureData.field_status_export,
        }
        break
      case 'Свободен':
      default:
        output.status = {
          state: 'free',
          name: featureData.field_status_export,
        }
        break
    }
  }

  if (featureData.field_ploschad_export) {
    output.area = (Number.parseFloat(featureData.field_ploschad_export) / 100).toFixed(2)
  }

  if (featureData.field_cena_za_uchastok_export) {
    output.priceTotalNum = Number.parseInt(featureData.field_cena_za_uchastok_export, 10)
  }

  if (featureData.field_cena_za_uchastok_discount_export) {
    output.priceTotalDiscountNum = Number.parseInt(featureData.field_cena_za_uchastok_discount_export, 10)
  }

  if (featureData.field_cena_za_sotku_export) {
    output.pricePerNum = Number.parseInt(featureData.field_cena_za_sotku_export, 10)
  }

  if (featureData.field_cena_za_sotku_discount_export) {
    output.pricePerDiscountNum = Number.parseInt(featureData.field_cena_za_sotku_discount_export, 10)
  }

  if (featureData.field_kad_nomer_export) {
    output.kad = featureData.field_kad_nomer_export
  }

  if (featureData.field_link_to_special_export) {
    output.field_link_to_special_export = featureData.field_link_to_special_export
  }

  return output
}

export type plotStatus = 'discount' | 'free' | 'hold' | 'mortgage' | 'sold' | 'special' | undefined

export type featureProcessedData = {
  name: string;
  status: { state: plotStatus, name: string } | undefined;
  area: string | undefined;
  priceTotalNum: number | undefined;
  priceTotalDiscountNum: number | undefined;
  pricePerNum: number | undefined;
  pricePerDiscountNum: number | undefined;
  kad: string | undefined;
  field_link_to_special_export: string | undefined;
}
